const blocks = document.querySelectorAll(
  ".wp-block-adspire-ai-testimonials-tabs"
);

if (blocks.length) {
  import("./view-frontend").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
